/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import e from"react";import{useIsoMorphicEffect as o}from"./use-iso-morphic-effect.js";import{useServerHandoffComplete as r}from"./use-server-handoff-complete.js";import{env as t}from"../utils/env.js";var s;let u=null!=(s=e.useId)?s:function(){let s=r(),[u,f]=e.useState(s?()=>t.nextId():null);return o((()=>{null===u&&f(t.nextId())}),[u]),null!=u?""+u:void 0};export{u as useId};
//# sourceMappingURL=use-id.js.map
